import "./relationshipHeader.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { withContainerContext } from "../../components/container/ContainerContext";
import SplitButton from "../../components/form/SplitButton";
import { withXScrollPositionContext } from "../../components/scrollable/ScrollPositionContext";
import { PropTypeShapes } from "../../types";

// import debugUtils from "../../utils/debugUtils";

class RelationshipCardHeaderView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      leftMostGroup: 0
    };

    this._liveLeft = 0;
    this._horizontalScrollerActive = false;
    this.stickyDomNode = null;

    this.getStyle = this.getStyle.bind(this);
    this.applyStyle = this.applyStyle.bind(this);

    this._liveScrollListeners = {
      onLiveScrollStart: this.onLiveScrollStart.bind(this),
      onLiveScrollUpdate: this.onLiveScrollUpdate.bind(this),
      onLiveScrollStop: this.onLiveScrollStop.bind(this)
    };
  }

  componentWillMount() {
    this.setState({
      leftMostGroup: 0
    });
  }

  componentDidMount() {
    this.props.xScrollActions.registerForLiveUpdates(this._liveScrollListeners);
  }

  componentWillReceiveProps(nextProps) {
    // debugUtils.logPropChanges("RelationshipCardHeaderView", this.props, nextProps, true);
    this.updateLeftColumnLabel(nextProps);
  }

  componentWillUnmount() {
    this.props.xScrollActions.unregisterForLiveUpdates(this._liveScrollListeners);
  }

  onLiveScrollStart(horizontalScroller) {
    if (horizontalScroller) {
      this._horizontalScrollerActive = true;
      this.applyStyle();
    }
  }

  onLiveScrollUpdate(scrollLeft) {
    if (!isNil(scrollLeft) && scrollLeft !== this._liveLeft) {
      this._liveLeft = scrollLeft;
      this.updateLeftColumnLabel(this.props);
    }
  }

  onLiveScrollStop(horizontalScroller) {
    if (horizontalScroller) {
      this._horizontalScrollerActive = false;
      this.applyStyle();
    }
  }

  updateLeftColumnLabel(useProps) {
    // Work out which header should have the arrow... we want to pick the left-most one that has not started scrolling
    // off the screen...
    let sum = 0;
    const lefts = useProps.colGroups.map(g => {
      const result = sum;
      sum += g.width;
      return result;
    });
    const chosenColumn = Math.max(
      0,
      lefts.findLastIndex(l => l <= this._liveLeft)
    );
    if (this.state.leftMostGroup !== chosenColumn) {
      this.setState({ leftMostGroup: chosenColumn });
    }
  }

  applyStyle() {
    const style = this.getStyle();
    this._stickyDomNode.style.left = style.left;
    this._stickyDomNode.style.top = style.top;
    this._stickyDomNode.style.overflow = style.overflow;
    this._stickyDomNode.style.position = style.position;
  }

  getStyle() {
    let left = `${this._liveLeft}px`;
    let top = "0px";
    let overflow = null;
    let position = "absolute";
    const maxWidth = `${this.props.containerRect.width}px`;
    if (this._horizontalScrollerActive) {
      left = `${this.props.containerRect.left}px`;
      top = `${this.props.containerRect.top}px`;
      position = "fixed";
      overflow = "hidden";
    }

    return {
      left,
      top,
      overflow,
      position,
      maxWidth
    };
  }

  render() {
    const settingsId = `relationshipHeader-${this.props.viewIds.first()}`;
    const leftMostLabel = this.props.colGroups.size ? this.props.colGroups.get(this.state.leftMostGroup).label : null;

    const style = this.getStyle();

    return (
      <div className="relationshipHeaderScrollBlockout" style={style} ref={node => (this._stickyDomNode = node)}>
        <div className="relationshipHeaderColumnDropdown">
          <SplitButton
            label="Choose Columns"
            id={settingsId}
            onClick={this.props.onShowMenu}
            icon="rightArrow"
            iconPosition="right"
          />
        </div>
        <div className="relationshipHeaderGroupLabel">
          <span>{leftMostLabel}</span>
        </div>
      </div>
    );
  }
}

RelationshipCardHeaderView.propTypes = {
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  width: PropTypes.number.isRequired,
  colGroups: PropTypeShapes.relationshipColumnGroupList.isRequired,
  onShowMenu: PropTypes.func.isRequired,

  // From withScrollPositionContext
  xScrollActions: PropTypeShapes.scrollActions.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

// Subscribing to withXScrollPositionContext so that I can find out the current scroll position,
// and then grab the label for the left-most item...
export default withContainerContext(withXScrollPositionContext(RelationshipCardHeaderView));
